<template>
  <b-container class="d-flex flex-column ml-0 h-100">
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          <b-link
            class="text-body text-decoration-none"
            :to="{ name: 'calculator' }"
          >
            Kalkulácie
          </b-link>
        </h2>
      </div>
      <b-form inline class="mr-2">
        <b-form-select v-model="year" :select-size="1" @change="changeYear">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </b-form-select>
      </b-form>
      <div class="d-flex flex-grow-1">
        <h3
          v-if="$route.params.energetic === 'power'"
          class="text-power font-weight-normal mb-0"
        >
          <icon class="icon-fw" name="plug" />
          {{ title }}
        </h3>
        <h3
          v-if="$route.params.energetic === 'gas'"
          class="text-gas font-weight-normal mb-0"
        >
          <icon class="icon-fw" name="fire" />
          {{ title }}
        </h3>
      </div>
    </div>
    <transition mode="out-in" name="fadeShort" @loading="loading">
      <div v-if="!loading" ref="scroll" v-bar>
        <div>
          <component
            :is="`${energetic}-${type}-view`"
            v-if="energetic && type"
            ref="calc"
            :year="year"
          />
          <div class="d-flex">
            <div class="mb-4">
              <b-btn variant="outline-secondary" size="lg" @click="reset">
                Resetovať
              </b-btn>
              <b-btn class="ml-1" size="lg" variant="primary" @click="toPdf">
                <b-icon class="mr-1" icon="file-earmark-richtext" />
                Exportovať do PDF
              </b-btn>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </b-container>
</template>
<script>
import { saveAs } from 'file-saver'
import PowerReservedCapacityView from './power/ReservedCapacity'
import PowerAdvancePaymentView from './power/AdvancePayment'
import PowerBreakerRecalcView from './power/BreakerRecalc'

import GasDailyMaxView from './gas/DailyMax'
import GasAdvancePaymentView from './gas/AdvancePayment'

export default {
  components: {
    PowerReservedCapacityView,
    PowerAdvancePaymentView,
    PowerBreakerRecalcView,
    GasDailyMaxView,
    GasAdvancePaymentView,
  },
  data() {
    return {
      loading: false,
      year: this.$moment().year(),
      energetic: this.$route.params.energetic,
      type: this.$route.params.type,
    }
  },
  computed: {
    years() {
      let years = this.$helpers.datesBetween(
        [this.$moment(2021, 'YYYY'), this.$moment().add(1, 'month')],
        'years',
        'YYYY',
        'desc',
      )
      return years.map((item) => parseInt(item))
    },
    title() {
      switch (this.type) {
        case 'reserved-capacity':
          return 'Výpočet rezervovanej kapacity "RK"'
        case 'advance-payment':
          return 'Výpočet zálohovej platby'
        case 'breaker-recalc':
          return 'Prepočet hlavného ističa na RK'
        case 'daily-max':
          return 'Výpočet denného maximálneho množstva "DMM"'
      }
      return null
    },
  },
  methods: {
    changeYear(year) {
      this.year = year
    },
    reset() {
      this.$swal({
        title: 'Reset formulára',
        text: 'Skutočne chcete resetovať všetky zadané údaje?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$refs.calc.reset()
        }
      })
    },
    toPdf() {
      this.$api
        .post(
          'calculator/to_pdf',
          {
            data: { title: this.title, year: this.year },
            html: this.$refs.calc.$el.outerHTML,
          },
          { responseType: 'blob' },
        )
        .then((res) => {
          saveAs(
            new Blob([res.data]),
            `kalkulacie-${this.$options.filters.toSnake(this.title)}.pdf`,
          )
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {})
    },
  },
}
</script>
